import React from 'react';
import PropTypes from 'prop-types';
import { Section, Image } from 'components';
import './FullwidthImage.scss';

const FullwidthImage = ({ alt, comment, image }) => (
  <>
    {image && (
      <Section spaceless stick>
        <Image
          src={image}
          alt={alt}
          additionalClass={'fullwidth-image__image'}
        />
      </Section>
    )}
    {comment && (
      <Section spaceless>
        <div className={'article-content__container'}>
          <div className={'fullwidth-image__comment'}>{comment}</div>
        </div>
      </Section>
    )}
  </>
);

FullwidthImage.defaultProps = {
  alt: '',
  comment: '',
};

FullwidthImage.propTypes = {
  alt: PropTypes.string,
  comment: PropTypes.string,
  image: PropTypes.string.isRequired,
};

export default FullwidthImage;
